import React, { useEffect, useState } from "react";
import { fetchTvData } from "../../redux/reducers/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import { Button, Col, Container, Row } from "react-bootstrap";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import Modal from "react-modal";
import TvUpdateForm from "../../components/tv/tvUpdateForm";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { deleteTv } from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../../components/components-react/ReactAlert";
import { toast } from "react-toastify";
import { DeleteIcon, EditIcon } from "../../images/icons/website-icons";
import Loader from "../../components/ui/Loader";
import moment from "moment";
import useGymsData from "../../hooks/useGymsData";
import SelectDropdownLabel from "../../components/components-react/SelectDropdownLabel";
import CommonStructured from "../../components/common-components/CommonStructured";

const TV_CURRENT_STATUS = [
  { label: "Online", value: "online" },
  { label: "Offline", value: "offline" },
];

const Tv = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;

  const { TVData, loading } = useSelector((state) => state.api);

  const isAdmin = userInfoData?.account_type === "admin";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [initialValue, setInitialValue] = useState(null);
  const [isPage, setIsPage] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [pageLimit, setPageLimit] = useState(10);
  const [selectedGym, setSelectedGym] = useState(null);

  function onCloseModalvalues() {
    setModalOpen(false);
  }

  const {
    data: gymsData,
    isLoading: isLoadingGyms,
    isFetching: isFetchingGyms,
  } = useGymsData();

  const initialFilter = {
    search: "",
    status: "",
    limit: 10,
    gym_id: "",
    page: isPage + 1,
    start_date: "",
    end_date: "",
    tv_current_status: "",
  };

  const [filters, setFilters] = useState(initialFilter);

  // console.log("filters ===>", filters);

  const payload = {
    filters: filters,
    token: userInfoData?.token,
  };

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: isPage + 1,
      limit: pageLimit,
      gym_id: selectedGym ? selectedGym?.value : "",
    }));
  }, [selectedGym, pageLimit, isPage, filters.tv_current_status]);

  const getTvData = () => {
    dispatch(fetchTvData(payload));
  };

  useEffect(() => {
    getTvData();
  }, [userInfoData?.gym_id, filters]);

  const handleReset = () => {
    setFilters(initialFilter);
    setSelectedGym(null);
  };

  const handleAdd = () => {
    setIsEdit(false);
    setModalOpen(true);
    setInitialValue(null);
  };

  const handleEdit = (row) => {
    setIsEdit(true);
    setModalOpen(true);
    setInitialValue(row);
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: deleteTv,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getTvData();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "tv_name",
      text: "TV Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">{row?.tv_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "User Details",
      formatter: (cell, row) => {
        return (
          <div className="flex-k flex-col-k items-center-k fs-small-k userGap">
            <span className="tb-data minWidth100 bold-text">
              {row?.user_name || "NA"}
            </span>
            <span className="lowercase underline">
              {row?.user_email || "NA"} <br /> {row?.user_mobile || "NA"}
            </span>
          </div>
        );
      },
    },
    // {
    //   dataField: "user_email",
    //   text: "User Email",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">{row?.user_email || "NA"}</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "user_mobile",
    //   text: "User Mobile",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.user_mobile || "NA"}
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "user_email",
    //   text: "User Email",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">{row?.user_email || "NA"}</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "user_mobile",
    //   text: "User Mobile",
    //   formatter: (cell, row) => {
    //     return (
    //       <span className="tb-data minWidth100">
    //         {row?.user_mobile || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "tv_last_status",
      text: "TV Last Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100 status-dot d-flex align-items-center gap-2 justify-content-center">
            <span
              className="d-inline-block rounded-circle"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor:
                  row?.tv_last_status?.toLowerCase() === "online"
                    ? "#28a745"
                    : row?.tv_last_status?.toLowerCase() === "offline"
                    ? "#dc3545"
                    : "#000",
              }}
            />
            {row?.tv_last_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "tv_current_status",
      text: "TV Current Status",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100 status-dot d-flex align-items-center gap-2 justify-content-center">
            <span
              className="d-inline-block rounded-circle"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor:
                  row?.tv_current_status.toLowerCase() === "online"
                    ? "#28a745"
                    : row?.tv_current_status.toLowerCase() === "offline"
                    ? "#dc3545"
                    : "#000",
              }}
            />
            <span
              style={{
                color:
                  row?.tv_current_status.toLowerCase() === "online"
                    ? "#28a745"
                    : row?.tv_current_status.toLowerCase() === "offline"
                    ? "#dc3545"
                    : "#000",
              }}
            >
              {row?.tv_current_status || "NA"}
            </span>
          </span>
        );
      },
    },
    {
      dataField: "offline_duration",
      text: "TV Offline Duration",
      formatter: (cell, row) => {
        const { years, months, days, hours, minutes, seconds } =
          row?.offline_duration || {};

        const parts = [];
        if (years !== undefined) parts.push(`${years}y`);
        if (months !== undefined) parts.push(`${months}mo`);
        if (days !== undefined) parts.push(`${days}d`);
        if (hours !== undefined) parts.push(`${hours}h`);
        if (minutes !== undefined) parts.push(`${minutes}m`);
        // if (seconds !== undefined) parts.push(`${seconds}s`);

        return (
          <span className="tb-data minWidth100">
            {row?.tv_current_status?.toLowerCase() === "online"
              ? "NA"
              : parts.length > 0
              ? parts.join(" ")
              : "NA"}
          </span>
        );
      },
    },
    // {
    //   dataField: "offline_duration",
    //   text: "TV Offline Duration",
    //   formatter: (cell, row) => {
    //     const duration = row?.offline_duration;

    //     return (
    //       <span className="tb-data minWidth100 status-dot d-flex align-items-center gap-2 justify-content-center">
    //         <span
    //           className="d-inline-block rounded-circle"
    //           style={{
    //             width: "8px",
    //             height: "8px",
    //             backgroundColor:
    //               row?.tv_current_status.toLowerCase() === "online"
    //                 ? "#28a745"
    //                 : row?.tv_current_status.toLowerCase() === "offline"
    //                 ? "#dc3545"
    //                 : "#000",
    //           }}
    //         />
    //         <span
    //           style={{
    //             color:
    //               row?.tv_current_status.toLowerCase() === "online"
    //                 ? "#28a745"
    //                 : row?.tv_current_status.toLowerCase() === "offline"
    //                 ? "#dc3545"
    //                 : "#000",
    //           }}
    //         >
    //           {row?.tv_current_status || "NA"}
    //         </span>
    //       </span>
    //     );
    //   },
    // },
    // {
    //   dataField: "offline_duration",
    //   text: "TV Offline Duration",
    //   formatter: (cell, row) => {
    //     const duration = row?.offline_duration;

    //     return (
    //       <span className="tb-data minWidth100">
    //         {duration
    //           ? `${duration.days || 0}d ${duration.minutes || 0}m ${
    //               duration.seconds || 0
    //             }s`
    //           : "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added
              ? moment(row.date_added)?.format("DD-MM-YYYY")
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => handleEdit(row)}
          >
            <EditIcon />
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}
          >
            {loading ? <Loader /> : <DeleteIcon />}
          </button>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: TV AT WTF">
      <Container className="bg-cloud-k px-50px" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"TV at WTF"}
              createBtnTxt={isAdmin || isClusterManager ? "+ Add New TV" : null}
              onClickCreateBtn={handleAdd}
              isReload={() => getTvData(filters)}
            />
          </Col>
        </Row>

        <div className="cmnFilterStructureContainer ptTrackContainer mt30">
          <div className="filterblock gridSpanTwo">
            <div className="filterHeadingNBtn">
              <h5 className="filterHeading">All Filters</h5>
              <Button variant="outline-danger" onClick={handleReset}>
                Reset Filter
              </Button>
            </div>

            <div className="filterblock grid__three">
              <div className={`commonWrapper dropdownCommonWrapper `}>
                <SelectDropdownLabel
                  options={gymsData?.length > 0 ? gymsData : []}
                  value={selectedGym}
                  setSelectedOption={(selectedOption) =>
                    setSelectedGym(selectedOption)
                  }
                  name="Select Gym"
                />
              </div>
              <div className={`commonWrapper dropdownCommonWrapper `}>
                <SelectDropdownLabel
                  options={TV_CURRENT_STATUS}
                  value={
                    filters.tv_current_status
                      ? TV_CURRENT_STATUS.find(
                          (item) => item.value === filters.tv_current_status
                        )
                      : null
                  }
                  setSelectedOption={(selectedOption) =>
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      tv_current_status: selectedOption?.value || "",
                    }))
                  }
                  name="TV Current Status"
                />
              </div>
              {/* <div
                className={`closure-date-picker commonWrapper commonWrapper dropdownCommonWrapper `}
              >
                <input
                  type="date"
                  className={`${filters.followup_date ? "date-has-value" : ""}`}
                  value={filters.followup_date}
                  onChange={handleChangeDate}
                />
              </div> */}
            </div>
          </div>
        </div>

        <div>
          <Modal
            isOpen={modalOpen}
            onRequestClose={onCloseModalvalues}
            contentLabel="Career Modal"
            ariaHideApp={false}
          >
            <TvUpdateForm
              getTvData={getTvData}
              isEdit={isEdit}
              closeModal={onCloseModalvalues}
              initialValues={initialValue}
              token={userInfoData?.token}
            />
          </Modal>

          <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt-3">
            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <PaymentLinkTable
                tableData={TVData?.data?.length > 0 ? TVData?.data : []}
                tableColumns={tbColumns}
                tablePagination={
                  TVData?.pagination?.length > 0 ? TVData?.pagination : []
                }
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                setPageLimit={setPageLimit}
                pageLimit={pageLimit}
              />
            )}
          </div>
        </div>
      </Container>
    </HelmetWrapper>
  );
};

export default Tv;
